import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * VerifiedBadge - Custom verification badge (Twitter/X style)
 *
 * Blue starburst for verified creators, purple shield for admins.
 * Properly sized and centered with bold white checkmark.
 */
const VerifiedBadge = ({ type = 'creator', size = 20, className = '' }) => {
  const { t } = useTranslation('common');
  if (type === 'admin') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 22 22"
        fill="none"
        className={`inline-block flex-shrink-0 ${className}`}
        aria-label={t('label.admin', 'Admin')}
      >
        <path
          d="M11 1L4.5 4.5v4.5c0 4.7 2.8 9.1 6.5 10.5 3.7-1.4 6.5-5.8 6.5-10.5V4.5L11 1z"
          fill="#7C3AED"
        />
        <path
          d="M9.3 14.1l-3-3 1.4-1.4 1.6 1.6 4-4 1.4 1.4-5.4 5.4z"
          fill="white"
        />
      </svg>
    );
  }

  // Twitter/X style verified badge
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={`inline-block flex-shrink-0 ${className}`}
      aria-label={t('label.verified', 'Verified')}
    >
      <path
        d="M20.396 11c.745-.765.672-1.685.466-2.475-.18-.68-.678-1.29-1.347-1.643.326-.78.2-1.726-.35-2.41-.543-.67-1.407-1.024-2.27-.943-.2-.8-.752-1.473-1.49-1.838-.755-.372-1.6-.35-2.328.008C12.37.96 11.465.5 10.5.5c-.963 0-1.868.46-2.577 1.2-.728-.358-1.573-.38-2.328-.008-.738.365-1.29 1.038-1.49 1.838-.863-.08-1.727.273-2.27.944-.55.683-.676 1.63-.35 2.41-.67.352-1.167.962-1.347 1.642-.206.79-.28 1.71.466 2.475-.745.765-.672 1.685-.466 2.475.18.68.678 1.29 1.347 1.643-.326.78-.2 1.726.35 2.41.543.67 1.407 1.024 2.27.943.2.8.752 1.473 1.49 1.838.755.372 1.6.35 2.328-.008.71.74 1.614 1.2 2.577 1.2.963 0 1.868-.46 2.577-1.2.728.358 1.573.38 2.328.008.738-.365 1.29-1.038 1.49-1.838.863.08 1.727-.273 2.27-.944.55-.683.676-1.63.35-2.41.67-.352 1.167-.962 1.347-1.642.206-.79.28-1.71-.466-2.475z"
        fill="#1D9BF0"
      />
      <path
        d="M9.585 14.645l-3.89-3.89 1.414-1.414 2.476 2.476 4.89-4.89 1.414 1.414-6.304 6.304z"
        fill="white"
      />
    </svg>
  );
};

export default VerifiedBadge;
